module.exports = __webpack_public_path__ + "static/media/card_img_01.bb897555.jpg";